
import Vue from 'vue';
import Component from 'vue-class-component';
import { authModule } from '@/utils/store-acessor';
import SectionLayout from '@/components/SectionLayout.vue';
import NavBar from '@/components/NavBar/NavBar.vue';
import BackgroundVideo from '@/components/BackgroundVideo.vue';
import SuccessCard from '@/components/Auth/SuccessCard.vue';
import { AuthApi } from '@/api/auth.api';
import { take } from 'rxjs/operators';
import { AuthenticatedModel } from '@/models/authenticated.model';

@Component({
  components: { SuccessCard, BackgroundVideo, NavBar, SectionLayout }
})
export default class ConfirmUserPage extends Vue {
  @authModule.Getter('isAuthenticated') isAuthenticated!: boolean;
  validated = false;
  alreadyValidated = false;

  mounted() {
    const token = this.$route.params.token;
    if (!!token) {
      new AuthApi()
        .confirmUser(token)
        .pipe(take(1))
        .subscribe(
          res => {
            this.validated = true;
          },
          err => {
            const msg: string = err.message;
            if (msg.includes('422')) {
              this.alreadyValidated = true;
            }
          }
        );
    }
  }
}
